<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_events">
  <h2>You do not have permission to manage custom inboxes.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().can_manage_events && serverError === null">

  <h2>
    Custom Inbox Configuration
    <span *ngIf="loadingCustomInboxes" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingCustomInboxes && customInboxList && customInboxList.results">({{ customInboxList.count.toLocaleString() }})</span>
  </h2>

  <div class="alert" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter custom inboxes by name"
             [(ngModel)]="filters.search"
             (ngModelChange)="this.filtersChangedSubject.next()">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix">
      <select class="custom-select" style="width: 150px;"
              [(ngModel)]="filters.status"
              (ngModelChange)="this.filtersChangedSubject.next()">
        <option [ngValue]="undefined">All Statuses</option>
        <option [ngValue]="CustomInboxStatus.active">Active</option>
        <option [ngValue]="CustomInboxStatus.draft">Draft</option>
        <option [ngValue]="CustomInboxStatus.retired">Retired</option>
      </select>
      <a class="btn btn-success float-right"
         routerLink="/admin/custom-inboxes/add">
        Create New Custom Inbox
      </a>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Name</th>
        <th># Active Items</th>
        <th># Total</th>
        <th>Status</th>
        <th></th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let customInbox of customInboxList.results">
        <td>{{ customInbox.name }}</td>
        <td>
          <ng-container *ngIf="customInbox.status === CustomInboxStatus.active">
            {{ customInbox.num_active_items }}
          </ng-container>
        </td>
        <td>{{ customInbox.num_all_time_items }}</td>
        <td>
          <span *ngIf="customInbox.status === CustomInboxStatus.draft" class="text-secondary">Draft</span>
          <span *ngIf="customInbox.status === CustomInboxStatus.active" class="text-success">Active</span>
          <span *ngIf="customInbox.status === CustomInboxStatus.retired" class="text-danger">Retired</span>
        </td>
        <td class="table-button-cell">
          <div class="float-right">
            <a routerLink="/admin/custom-inboxes/edit/{{ customInbox.id }}"
               class="btn btn-outline-primary btn-sm mr-1">
              Edit
            </a>
            <a routerLink="/inbox/custom/"
               [queryParams]="{inbox_id: customInbox.id}"
               class="btn btn-outline-primary btn-sm">
              View
            </a>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99" class="text-muted">
          <span *ngIf="loadingCustomInboxes">
            Loading...
          </span>
          <span *ngIf="!loadingCustomInboxes">
            No custom inboxes
            <ng-container *ngIf="filtersApplied">matching filters</ng-container>
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeCustomInboxConfig" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</div>
